import { PaymentMethod } from '@spa/store/modules/orderHistory/types'

/**
 * @see src/ReadModel/Subscription/Contracted/ContractedSubscription.php
 */
export type RawContractedSubscription = EnabledSubscriptionResponse | CancelledSubscriptionResponse

interface BaseRawResponse {
  readonly id: string
  readonly short_id: string
  readonly contracted_at: string
  readonly delivery: {
    readonly  customer: {
      readonly  name: string
    }
    readonly address: {
      readonly postal_code: string
      readonly region: string
      readonly city: string
      readonly address_line: string
    }
    readonly tel: string
    readonly method: {
      name: string
    }
  }
  readonly payment: {
    readonly total_price: number
    readonly delivery_fee: number|null
    readonly commission: number|null
    readonly method: PaymentMethod & {
      detail: object
    }
  }
  readonly frequency: {
    readonly unit: {
      readonly label: string
    }
    readonly value: number
  }
  readonly cancel: {
    readonly enable_range: {
      readonly begin: string
      readonly end: string
    }
    readonly enable: boolean
  }
}
export interface EnabledSubscriptionResponse extends BaseRawResponse {
  readonly schedule: {
    readonly next: string
  }
  readonly status: {
    readonly cancelled: false
  }
}
export interface CancelledSubscriptionResponse extends BaseRawResponse {
  readonly schedule: {
    readonly next: null
  }
  readonly status: {
    readonly cancelled: true
  }
}

export function isCancelled(r: RawContractedSubscription): r is CancelledSubscriptionResponse {
  return r.status.cancelled
}
